module.exports = __webpack_public_path__ + "static/media/CFH3.dcbef0aa.mov";